import styled from 'styled-components';
export const ContextIndicatorContainer = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.sm}px;
  width: fit-content;
  max-width: 100%;
  box-sizing: border-box;
  margin: ${({ theme }) => `${theme.spacing.md}px 0 ${theme.spacing.sm}px`};
  padding: 0 ${({ theme }) => theme.spacing.md}px;
`;
